import { useContext } from 'react';

import { SocialProfileContext } from '../context/SocialProfileContext';

export const useSocialProfileContext = () => useContext(SocialProfileContext);
